import React, { useEffect, useState } from 'react';
import { ACTIVE_DEVICE } from '../../../common/constant/common-constants';
import './Machines.css';

const AddMachineModal = ({ onClose, onSave, bedId }) => {
  const [machineType, setMachineType] = useState('ventilator');
  const [machineId, setMachineId] = useState('');
  const [errors, setErrors] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  const validate = () => {
    if (!machineType) {
      setErrors('Please select a machine type.');
      return false;
    }

    if (!machineId.trim()) {
      setErrors('Machine UDI is required.');
      return false;
    }

    setErrors('');
    return true;
  };

  const handleSave = () => {
    if (loading) return;
    setLoading(true);

    if (validate()) {
      onSave({
        bedId,
        machineId: machineId.trim(),
        name: '',
        machineType,
      });
      setLoading(false);
      return;
    }

    setLoading(false);
  };

  return (
    <div className="modal add-machine-modal" role="dialog" aria-modal="true" aria-labelledby="add-machine-title">
      <div className="backdrop" onClick={onClose} aria-hidden="true" />
      <div className="modal-content add-machine-modal__content">
        <header className="add-machine-modal__header">
          <div>
            <h2 id="add-machine-title">Add machine</h2>
            <p className="add-machine-modal__subtitle">Assign a device to this bed</p>
          </div>
          <button
            type="button"
            className="add-machine-modal__close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </header>

        <div className="add-machine-modal__field">
          <span className="add-machine-modal__label">Machine type</span>
          <div className="add-machine-modal__types">
            <button
              type="button"
              className={`add-machine-modal__type${machineType === 'ventilator' ? ' add-machine-modal__type--active' : ''}`}
              onClick={() => {
                setMachineType('ventilator');
                setErrors('');
              }}
            >
              <span className="add-machine-modal__type-name">{ACTIVE_DEVICE.V730i}</span>
              <span className="add-machine-modal__type-meta">Ventilator</span>
            </button>
          </div>
        </div>

        {machineType && (
          <div className="input-group add-machine-modal__field">
            <label className="add-machine-modal__label" htmlFor="add-machine-udi">
              Machine UDI
            </label>
            <input
              id="add-machine-udi"
              type="text"
              value={machineId}
              onChange={(event) => {
                setMachineId(event.target.value);
                if (errors) setErrors('');
              }}
              onKeyDown={(event) => {
                if (event.key === 'Enter') handleSave();
              }}
              placeholder="Enter machine UDI"
              autoFocus
            />
          </div>
        )}

        {errors && <p className="error add-machine-modal__error">{errors}</p>}

        <div className="actions add-machine-modal__actions">
          <button type="button" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button type="button" onClick={handleSave} disabled={loading}>
            {loading ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddMachineModal;
